import { render, staticRenderFns } from "./PdfViewerComponent.vue?vue&type=template&id=9e483880&scoped=true"
import script from "./PdfViewerComponent.vue?vue&type=script&lang=js"
export * from "./PdfViewerComponent.vue?vue&type=script&lang=js"
import style0 from "./PdfViewerComponent.vue?vue&type=style&index=0&id=9e483880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e483880",
  null
  
)

export default component.exports